import { storage } from "@/lib/storage";

export const PROFILE_KEY = "atlas.trip.profile";
export const INTERESTS = ["culture", "adventure", "shopping"];
export const CORE = ["AE", "MA", "EG", "JO", "SA", "QA", "OM", "TN"];

/** Origin countries: code, lang hint for Google Maps, currency for partner links, main airport (IATA city code). */
export const ORIGINS = [
  ["IT", "it", "EUR", "ROM"], ["FR", "fr", "EUR", "PAR"], ["DE", "de", "EUR", "BER"], ["ES", "es", "EUR", "MAD"], ["PT", "pt", "EUR", "LIS"],
  ["GB", "en", "GBP", "LON"], ["IE", "en", "EUR", "DUB"], ["BE", "fr", "EUR", "BRU"], ["NL", "nl", "EUR", "AMS"], ["CH", "de", "CHF", "ZRH"],
  ["AT", "de", "EUR", "VIE"], ["SE", "sv", "SEK", "STO"], ["NO", "no", "NOK", "OSL"], ["DK", "da", "DKK", "CPH"], ["PL", "pl", "PLN", "WAW"],
  ["GR", "el", "EUR", "ATH"], ["TR", "tr", "TRY", "IST"], ["RU", "ru", "RUB", "MOW"], ["US", "en", "USD", "NYC"], ["CA", "en", "CAD", "YTO"],
  ["MX", "es", "MXN", "MEX"], ["BR", "pt", "BRL", "SAO"], ["AR", "es", "ARS", "BUE"], ["AU", "en", "AUD", "SYD"], ["JP", "ja", "JPY", "TYO"],
  ["CN", "zh-CN", "CNY", "BJS"], ["KR", "ko", "KRW", "SEL"], ["IN", "en", "INR", "DEL"], ["PK", "ur", "PKR", "KHI"], ["ID", "id", "IDR", "JKT"],
  ["MY", "ms", "MYR", "KUL"], ["NG", "en", "NGN", "LOS"], ["ZA", "en", "ZAR", "JNB"], ["SN", "fr", "XOF", "DKR"],
  ["MA", "ar", "MAD", "CMN"], ["DZ", "ar", "DZD", "ALG"], ["TN", "ar", "TND", "TUN"], ["EG", "ar", "EGP", "CAI"], ["SA", "ar", "SAR", "RUH"],
  ["AE", "ar", "AED", "DXB"], ["QA", "ar", "QAR", "DOH"], ["KW", "ar", "KWD", "KWI"], ["JO", "ar", "JOD", "AMM"], ["LB", "ar", "LBP", "BEY"],
].map(([code, lang, currency, iata]) => ({ code, lang, currency, iata }));

/** Arrival airport (IATA) per destination. */
export const DEST_IATA = { AE: "DXB", MA: "RAK", EG: "CAI", JO: "AMM", SA: "RUH", QA: "DOH", OM: "MCT", TN: "TUN", BH: "BAH", KW: "KWI", LB: "BEY", IQ: "EBL", DZ: "ALG", LY: "TIP", SD: "KRT", MR: "NKC", SY: "DAM", YE: "SCT", PS: "AMM", DJ: "JIB", SO: "HGA", KM: "HAH", EH: "EUN" };

export const originName = (code, lang) => {
  try { return new Intl.DisplayNames([lang], { type: "region" }).of(code); } catch { return code; }
};

export const loadProfile = () => storage.getJSON(PROFILE_KEY, null);
export const saveProfile = (p) => storage.setJSON(PROFILE_KEY, p);

/** Travel style = the "viral" label shown after onboarding, derived from the chosen interests. */
export const travelStyle = (interests = []) => {
  const k = INTERESTS.filter((i) => interests.includes(i)).join("_");
  return `style_${k || "culture"}`;
};

export const DAY_THEMES = [
  { from: "#F6D5C3", to: "#E89B7B", ink: "#7A2E12" },
  { from: "#CFE3F5", to: "#8AB5DC", ink: "#1E3F60" },
  { from: "#D6EDDC", to: "#8FC9A3", ink: "#1F5A36" },
  { from: "#F7E6B5", to: "#E3C15A", ink: "#6B4E05" },
  { from: "#E6D6F2", to: "#B995D9", ink: "#4A2A6D" },
];
